export default __webpack_public_path__ + "static/media/prescription-icon.2188c751.svg";